import { render, staticRenderFns } from "./ExceptionTable.vue?vue&type=template&id=1b4ba25c&scoped=true&"
import script from "./ExceptionTable.vue?vue&type=script&lang=js&"
export * from "./ExceptionTable.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionTable.vue?vue&type=style&index=0&id=1b4ba25c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ba25c",
  null
  
)

export default component.exports